import { useLoggedOutCategoryPageLayoutElementsResponse } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageLayoutElementsResponse";

export const useLoggedOutCategoryPageLayoutElementsIsLoading = () => {
  const { isLoading } = useLoggedOutCategoryPageLayoutElementsResponse();
  return isLoading;
};
